import { Copy } from 'lucide-react';
import { Logo } from '../logo/logo';
import { Button } from '../ui/button';

export const MainErrorFallback = () => {
  const supportEmail = 'info@liquidbudget.com';

  const copyEmail = async () => {
    try {
      await navigator.clipboard.writeText(supportEmail);
      // Add toast notification here if desired
    } catch (err) {
      console.error('Failed to copy email:', err);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col items-center justify-center p-4">
      <div className="max-w-md w-full space-y-8 bg-white p-8 rounded-lg shadow-lg">
        {/* Logo */}
        <div className="flex justify-center text-2xl">
          <Logo textSize="text-4xl" iconSize="size-12" />
        </div>

        {/* Error Message */}
        <div className="text-center space-y-2">
          <h1 className="text-2xl font-semibold text-gray-900">Something went wrong :(</h1>
          <p className="text-gray-500">We apologize for the inconvenience. Our team has been notified.</p>
        </div>

        {/* Support Options */}
        <div className="space-y-4">
          <p className="text-sm font-medium text-gray-700 text-center">Need assistance? We're here to help:</p>

          {/* Email */}
          <div className="flex items-center justify-between rounded-md border border-gray-200 bg-gray-50 px-4 py-3">
            <span className="text-sm text-gray-600 font-medium">{supportEmail}</span>
            <button
              onClick={copyEmail}
              className="ml-2 rounded-md p-2 hover:bg-white transition-colors duration-200"
              title="Copy email address"
            >
              <Copy className="h-4 w-4 text-gray-500" />
            </button>
          </div>

          {/* Reddit */}
          <a
            href="https://reddit.com/r/liquidbudget"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center justify-center px-4 py-3 w-full text-sm font-medium text-white bg-orange-600 rounded-md hover:bg-orange-700 transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-orange-500"
          >
            Join our Reddit Community
          </a>
        </div>

        {/* Return Home Button */}
        <div className="mt-8 text-center">
          <Button onClick={() => window.location.assign(window.location.origin)} variant="outline" className="w-full">
            Return to Homepage
          </Button>
        </div>
      </div>
    </div>
  );
};
